// @flow
import * as R from "ramda"

import Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"
import type Journey from "common/records/Journey"
import type Options from "common/records/Options"
import { additionalServicesLoaded } from "booking/services/actionCreators"
import loadAncillaries3rdApi from "./api"
import { ancillaries3rdError } from "../actions"
import { getJourney } from "../../journey/reducer"
import { getFormattedPassengers } from "../../reservation/selectors/passengersSelectors"
import { startAncillariesLoading, stopAncillariesLoading } from "./actions"
import { type AncillaryService, DEFAULT_ANCILLARIES } from "./consts"

export type LoadAncillaries3rdParams = {
  services: AncillaryService[],
}

export type Ancillaries3rdRequestParams = {
  journey: Journey,
  passengers: Passenger[],
  options: Options,
}

const getAncillaries3rdRequestParams = (state): Ancillaries3rdRequestParams => ({
  options: state.options,
  journey: getJourney(state),
  passengers: getFormattedPassengers(state),
})

const getServices = R.propOr(DEFAULT_ANCILLARIES, "services")

// $FlowFixMe: Update types
export default (payload: LoadAncillaries3rdParams) => async (dispatch, getState) => {
  const state = getState()
  const params = getAncillaries3rdRequestParams(state)
  const services = getServices(payload)
  const startTime = Date.now()

  cuckoo.track(cuckooEvents.BOOKING_ANCILLARIES_3RD_API_TRIGGERED)

  // TODO: Remove this after fast track and paid checkin
  //       are refactored to new redux architecture
  dispatch(startAncillariesLoading(services))

  try {
    // Load ancillaries and dispatch them to ancillaries reducer
    const additionalServices = await loadAncillaries3rdApi(
      params.journey,
      params.passengers,
      params.options,
      services,
    )

    const duration = Date.now() - startTime
    cuckoo.track(cuckooEvents.BOOKING_ANCILLARIES_3RD_API_SUCCESS)
    cuckoo.track(cuckooEvents.BOOKING_ANCILLARIES_3RD_API_DURATION, {
      duration,
    })

    dispatch(stopAncillariesLoading(services))
    additionalServicesLoaded(additionalServices)(dispatch)
  } catch (err) {
    cuckoo.track(cuckooEvents.BOOKING_ANCILLARIES_3RD_API_ERROR, {
      error: JSON.stringify(err),
    })

    dispatch(ancillaries3rdError())
    dispatch(stopAncillariesLoading(services))
  }
}
